/*
 * NYORD: Bewertungskarten (sections/nb-rezensionen). Neue Bewertungen (Metaobjekte, im Daten-Skript der Section) und
 * Vitals-Archiv (assets/nb-bew-<gruppe>-<sprache>.json) zusammen, sortiert nach Sternen (beste zuerst, innerhalb einer
 * Stufe mit Foto und mit Text vorn), seitenweise als Mauerwerk: jede Karte kommt in die gerade kürzeste Spalte,
 * Spaltenzahl nach Breite (5/4/3/2). Die Verteilungsbalken filtern nach Sternen; nichts wird ausgeblendet. Lange Texte gekürzt mit „Mehr lesen“,
 * Fotos öffnen groß im Dialog, „Rezension schreiben“ öffnet das Formular (nach dem Absenden mit Dank wieder offen).
 * Texte nur per textContent, Kundentexte kommen nie als HTML in die Seite.
 */
if (!customElements.get('nb-rezensionen')) {
  customElements.define(
    'nb-rezensionen',
    class extends HTMLElement {
      connectedCallback() {
        const daten = JSON.parse(this.querySelector('[data-nb-rez-daten]').textContent);
        this.texte = daten.texte;
        this.seite = daten.seite || 20;
        this.eintraege = daten.neu || [];
        this.gezeigt = 0;
        this.karten = [];
        this.raster = this.querySelector('[data-nb-rez-raster]');
        this.status = this.querySelector('[data-nb-rez-status]');
        this.mehr = this.querySelector('[data-nb-rez-mehr]');
        this.leiste = this.querySelector('[data-nb-rez-leiste]');
        this.ordnung = this.querySelector('[data-nb-rez-ordnung]');
        this.alleKnopf = this.querySelector('[data-nb-rez-alle]');
        this.filterKnoepfe = this.querySelectorAll('[data-nb-rez-filter]');
        this.stufe = 0;
        this.liste = [];
        this.stern = this.querySelector('[data-nb-rez-stern]').content.firstElementChild;
        this.haken = this.querySelector('[data-nb-rez-haken]').content.firstElementChild;
        this.spaltenZahl = 0;

        this.mehr.addEventListener('click', () => this.zeigen(this.seite));
        this.filterKnoepfe.forEach((k) =>
          k.addEventListener('click', () => this.geladen && this.filtern(this.stufe === +k.dataset.nbRezFilter ? 0 : +k.dataset.nbRezFilter, true))
        );
        this.alleKnopf.addEventListener('click', () => this.filtern(0, true));
        this.bildDialog();
        this.formDialog();

        const fertig = () => {
          this.status?.remove();
          this.geladen = true;
          this.sortieren();
          this.filtern(0);
        };
        if (!daten.archiv) return fertig();
        fetch(daten.archiv)
          .then((a) => {
            if (!a.ok) throw new Error(a.status);
            return a.json();
          })
          .then((archiv) => {
            this.eintraege = this.eintraege.concat(archiv.r || []);
            fertig();
          })
          .catch(() => {
            if (this.eintraege.length) return fertig();
            if (this.status) this.status.textContent = this.texte.fehler;
          });

        new ResizeObserver(() => {
          if (this.spalten) this.spaltenPruefen();
        }).observe(this.raster);
      }

      spaltenSoll() {
        const b = this.raster.clientWidth;
        if (b >= 1150) return 5;
        if (b >= 900) return 4;
        if (b >= 640) return 3;
        return 2;
      }

      // Spalten neu bauen, wenn sich die Zahl ändert; Karten in ursprünglicher Reihenfolge neu verteilen
      spaltenPruefen() {
        const soll = this.spaltenSoll();
        if (soll === this.spaltenZahl) return;
        this.spaltenZahl = soll;
        this.raster.style.setProperty('--nb-rez-spalten', soll);
        this.spalten = Array.from({ length: soll }, () => {
          const s = document.createElement('div');
          s.className = 'nb-rez__spalte';
          return s;
        });
        this.raster.replaceChildren(...this.spalten);
        this.karten.forEach((k) => this.einsortieren(k));
      }

      einsortieren(karte) {
        let ziel = this.spalten[0];
        for (const s of this.spalten) if (s.offsetHeight < ziel.offsetHeight - 2) ziel = s;
        ziel.append(karte);
      }

      // Beste zuerst; innerhalb einer Sternestufe Rezensionen mit Foto, dann mit Text vorn, sonst Reihenfolge wie geliefert
      sortieren() {
        const gewicht = (e) => +e.s * 10 + (e.f && e.f.length ? 2 : 0) + ((e.t || '').trim().length >= 40 ? 1 : 0);
        this.eintraege = this.eintraege
          .map((e, i) => [gewicht(e), i, e])
          .sort((a, b) => b[0] - a[0] || a[1] - b[1])
          .map((x) => x[2]);
      }

      // 0 = alle; 1–5 = nur diese Sternestufe. Baut die Karten neu auf
      filtern(stufe, vomKnopf) {
        this.stufe = stufe;
        this.liste = stufe ? this.eintraege.filter((e) => +e.s === stufe) : this.eintraege;
        this.filterKnoepfe.forEach((k) => k.setAttribute('aria-pressed', String(+k.dataset.nbRezFilter === stufe)));
        this.classList.toggle('nb-rez--gefiltert', stufe > 0);
        this.leiste.hidden = !stufe;
        this.alleKnopf.hidden = !stufe;
        this.ordnung.textContent = stufe ? this.texte.gefiltert.replace('%s%', stufe).replace('%n%', this.liste.length) : '';
        this.karten = [];
        this.gezeigt = 0;
        if (this.spalten) this.spalten.forEach((s) => s.replaceChildren());
        this.zeigen(this.seite);
        // Nach dem Antippen eines Balkens die Karten ins Bild holen, falls sie unterhalb liegen (Handy)
        if (vomKnopf && this.leiste.getBoundingClientRect().top > window.innerHeight * 0.6) {
          const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.leiste.scrollIntoView({ block: 'start', behavior: ruhig ? 'auto' : 'smooth' });
        }
      }

      zeigen(anzahl) {
        if (!this.spalten) this.spaltenPruefen();
        const neu = this.liste.slice(this.gezeigt, this.gezeigt + anzahl);
        neu.forEach((e) => {
          const k = this.karte(e);
          this.karten.push(k);
          this.einsortieren(k);
          this.kuerzen(k);
        });
        this.gezeigt += neu.length;
        this.mehr.hidden = this.gezeigt >= this.liste.length;
      }

      sterne(wert) {
        const p = document.createElement('p');
        p.className = 'nb-rez__sterne';
        p.setAttribute('role', 'img');
        p.setAttribute('aria-label', this.texte.sterne_label.replace('%w%', wert));
        for (let i = 1; i <= 5; i++) {
          const s = this.stern.cloneNode(true);
          if (i > wert) s.classList.add('nb-rez__stern-leer');
          p.append(s);
        }
        return p;
      }

      karte(e) {
        const k = document.createElement('article');
        k.className = 'nb-rez__karte';

        if (e.f && e.f.length) {
          const [url, w, h] = e.f[0];
          const knopf = document.createElement('button');
          knopf.type = 'button';
          knopf.className = 'nb-rez__foto';
          const img = document.createElement('img');
          img.src = `${url}?width=480`;
          img.srcset = [320, 480, 720].map((b) => `${url}?width=${b} ${b}w`).join(', ');
          img.sizes = `(min-width: 1150px) 240px, (min-width: 640px) 30vw, 46vw`;
          img.width = w;
          img.height = h;
          img.loading = 'lazy';
          img.alt = this.texte.foto_alt.replace('%name%', e.n);
          knopf.append(img);
          if (e.f.length > 1) {
            const z = document.createElement('span');
            z.className = 'nb-rez__foto-zahl';
            z.textContent = e.f.length;
            z.setAttribute('aria-label', this.texte.fotos_anzahl.replace('%n%', e.f.length));
            knopf.append(z);
          }
          knopf.addEventListener('click', () => this.bildOeffnen(e, 0));
          k.append(knopf);
        }

        const inhalt = document.createElement('div');
        inhalt.className = 'nb-rez__inhalt';
        const name = document.createElement('p');
        name.className = 'nb-rez__name';
        name.textContent = e.n;
        if (e.v) {
          const h = document.createElement('span');
          h.className = 'nb-rez__haken';
          h.title = this.texte.verifiziert;
          h.setAttribute('role', 'img');
          h.setAttribute('aria-label', this.texte.verifiziert);
          h.append(this.haken.cloneNode(true));
          name.append(h);
        }
        inhalt.append(name, this.sterne(e.s));

        const text = document.createElement('p');
        text.className = 'nb-rez__text';
        text.textContent = e.t;
        inhalt.append(text);

        if (e.u) {
          const u = document.createElement('p');
          u.className = 'nb-rez__hinweis';
          u.textContent = this.texte.uebersetzt;
          inhalt.append(u);
        }
        if (e.a) {
          const a = document.createElement('div');
          a.className = 'nb-rez__antwort';
          const kopf = document.createElement('p');
          kopf.className = 'nb-rez__antwort-kopf';
          kopf.textContent = this.texte.antwort;
          const t = document.createElement('p');
          t.textContent = e.a;
          a.append(kopf, t);
          inhalt.append(a);
        }
        k.append(inhalt);
        return k;
      }

      // Text auf einige Zeilen gekürzt; „Mehr lesen“ nur, wenn wirklich etwas abgeschnitten ist
      kuerzen(k) {
        const text = k.querySelector('.nb-rez__text');
        text.classList.add('nb-rez__text--kurz');
        if (text.scrollHeight <= text.clientHeight + 2) {
          text.classList.remove('nb-rez__text--kurz');
          return;
        }
        const knopf = document.createElement('button');
        knopf.type = 'button';
        knopf.className = 'nb-rez__lesen';
        knopf.textContent = this.texte.mehr_lesen;
        knopf.setAttribute('aria-expanded', 'false');
        knopf.addEventListener('click', () => {
          const offen = text.classList.toggle('nb-rez__text--kurz') === false;
          knopf.textContent = offen ? this.texte.weniger : this.texte.mehr_lesen;
          knopf.setAttribute('aria-expanded', String(offen));
        });
        text.after(knopf);
      }

      bildDialog() {
        this.bild = this.querySelector('[data-nb-rez-bild]');
        this.bildImg = this.bild.querySelector('[data-nb-rez-bild-img]');
        this.bildText = this.bild.querySelector('[data-nb-rez-bild-text]');
        this.zurueck = this.bild.querySelector('[data-nb-rez-zurueck]');
        this.weiter = this.bild.querySelector('[data-nb-rez-weiter]');
        this.zurueck.addEventListener('click', () => this.bildOeffnen(this.bildEintrag, this.bildNr - 1));
        this.weiter.addEventListener('click', () => this.bildOeffnen(this.bildEintrag, this.bildNr + 1));
        this.bild.addEventListener('keydown', (ev) => {
          if (ev.key === 'ArrowLeft' && !this.zurueck.hidden) this.zurueck.click();
          if (ev.key === 'ArrowRight' && !this.weiter.hidden) this.weiter.click();
        });
        this.schliessbar(this.bild);
      }

      bildOeffnen(e, nr) {
        const fotos = e.f;
        nr = (nr + fotos.length) % fotos.length;
        this.bildEintrag = e;
        this.bildNr = nr;
        const [url, w, h] = fotos[nr];
        this.bildImg.src = `${url}?width=1400`;
        this.bildImg.width = w;
        this.bildImg.height = h;
        this.bildImg.alt = this.texte.foto_alt.replace('%name%', e.n);
        this.bildText.textContent = fotos.length > 1 ? `${e.n} · ${nr + 1}/${fotos.length}` : e.n;
        this.zurueck.hidden = this.weiter.hidden = fotos.length < 2;
        if (!this.bild.open) this.bild.showModal();
      }

      formDialog() {
        this.form = this.querySelector('[data-nb-rez-form]');
        if (!this.form) return;
        this.querySelector('[data-nb-rez-schreiben]')?.addEventListener('click', () => this.form.showModal());
        this.schliessbar(this.form);
        // Nach dem Absenden lädt Shopify die Seite neu: Dank oder Fehler gleich wieder im Dialog zeigen
        if (this.form.querySelector('[data-nb-rez-gesendet], [data-nb-rez-formfehler]')) {
          this.closest('section')?.scrollIntoView({ block: 'start' });
          this.form.showModal();
        }
      }

      // Schließen per Knopf und per Klick auf den abgedunkelten Rand
      schliessbar(dialog) {
        dialog.querySelector('[data-nb-rez-zu]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (ev) => {
          if (ev.target === dialog) dialog.close();
        });
      }
    }
  );
}
